import React from "react";
import PropTypes from "prop-types";
import { InputText, Label } from "../../../components/Inputs";
import { validateEmail, validateTelNumber } from "../../../components/Utils";

const BasicDataChangeFormContent = (props) => {
  const { className, forwardedRef } = props;
  const [state, setFormState] = React.useState(() => {
    const model = props.model || {};
    return {
      email: model.email || "",
      cellNumber: model.cellNumber || "",
      preferredContactMethod: model.preferredContactMethod || "email",
      error: {
        cellNumber: null,
        email: null,
      },
    };
  });
  // class-style partial merge so former this.setState(patch) call sites stay valid
  const setState = (patch) => setFormState((prev) => ({ ...prev, ...patch }));

  const validate = () => {
    const { error, ...model } = state;
    // check if all values are set
    let isValid = true;
    Object.keys(model).forEach((key) => {
      if (error[key] !== undefined && model[key] === "") {
        error[key] = "";
        isValid = false;
      }
    });
    // email
    model.email = model.email.trim();
    console.log(
      ">> validating email ...",
      model.email,
      validateEmail(model.email),
    );
    if (!validateEmail(model.email)) {
      // error.email = 'ungültige E-Mail';
      error.email = "E-Mail ist ungültig (Umlaute/Sonderzeichen entfernen)";
      isValid = false;
    }
    // cell number
    model.cellNumber = model.cellNumber.trim();
    if (!validateTelNumber(model.cellNumber)) {
      error.cellNumber = "ungültige Handynummer";
      isValid = false;
    }
    setState({ error });
    if (!isValid) {
      return null;
    }
    // copy original data
    const { id, firstname, lastname, username } = props.model;
    return { ...model, id, firstname, lastname, username };
  };
  const getModel = () => validate();
  React.useImperativeHandle(forwardedRef, () => ({ getModel }));

  const { email, cellNumber, error } = state;
  return (
    <div className={className}>
      <div className={`${error.email && "error-group"}`}>
        <Label htmlFor="email">
          {`E-Mail`}
          <span>*</span>
        </Label>
        <InputText
          id="email"
          autoFocus
          className=""
          value={email}
          onChange={(event) => setState({ email: event.target.value })}
        />
        {error.email && <div className="pad-sm-top">{error.email}</div>}
      </div>
      <div className={`pad-top ${error.cellNumber && "error-group"}`}>
        <Label htmlFor="cellNumber">
          {`Telefon (mobil)/Festnetz`}
          <span>*</span>
        </Label>
        <InputText
          id="cellNumber"
          className=""
          value={cellNumber}
          onChange={(event) => setState({ cellNumber: event.target.value })}
        />
        {error.cellNumber && (
          <div className="pad-sm-top">{error.cellNumber}</div>
        )}
      </div>
    </div>
  );
};

BasicDataChangeFormContent.propTypes = {
  className: PropTypes.string,
  model: PropTypes.object,
};

export default React.forwardRef((props, ref) => (
  <BasicDataChangeFormContent {...props} forwardedRef={ref} />
));
